/* /client/src/forms/ExchCapForm/index.js */
/* Exchange Capture Form: input lines     */

import React, { Component } from "react";
//import "./style.css"

class ExchCapForm extends Component {
   constructor(props) {
      super(props);
  
      this.inputRef = React.createRef();
    }
   /* ---------------------------------------------------------- * /
   componentDidMount() {
      if (this.props.state.statusCapForm === "inicio") { this.inputRef.current.focus(); };
   };
   /* ---------------------------------------------------------- * /
   componentDidUpdate() {
      if (this.props.state.statusCapForm === "inicio") { this.inputRef.current.focus(); };
   };
   /* ---------------------------------------------------------- */

   render() {
      return (
         <div className="">
            <form>

               <div className="row">   {/* ---------- Row 1 ---------- */}
                  <div className="col-6">
                     <label> Product Id </label>
                        <input 
                           type="text"
                           autoFocus="autofocus" //{this.props.state.form.usr_prod_id.autofocus}
                           id="usr_prod_id" 
                           className={this.props.state.form.usr_prod_id.className}
                           aria-describedby="usr_prod_id"
                           value={this.props.state.form.usr_prod_id.value}
                           onChange={this.props.handleDetChange}
                           //ref={this.inputRef}
                           onBlur={this.props.checkDetailVal}
                        />
                  </div>

                  <div className="col-6">
                     <label> Product Name </label>
                     <input type="text" 
                            id="prod_desc"
                            className="form-control" 
                            aria-describedby="prod_desc"
                            value={this.props.state.prod_desc}
                            disabled
                     />

                  </div>


               </div>

               <div className="row">   {/* ---------- Row 2 ---------- */}
                  <div className="col-6">
                     <label> Quantity </label>
                     <input type="number" 
                            id="quantity" 
                            className="form-control" 
                            aria-describedby="quantity"
                            value={this.props.state.form.quantity.value}
                            onChange={this.props.handleDetChange} />
                  </div>
                  
                  <div className="col-6">
                     <label> Unit of Measure </label>
                     <input type="text" 
                            id="unit_measure" 
                            className="form-control" 
                            aria-describedby="unit_measure"
                            value={this.props.state.form.unit_measure.value}
                            disabled
                     />

                  </div>

               </div>

               <div className="row">   {/* ---------- Row 3 ---------- */}
                  <div className="col-6">
                     <label> Unit Cost </label>
                     <input type="number" 
                            id="unit_cost" 
                            className="form-control" 
                            aria-describedby="unit_cost"
                            value={this.props.state.form.unit_cost.value}
                            onChange={this.props.handleDetChange}
                     />
                  </div>
                  <div className="col-6">
                     <label> Unit Price </label>
                     <input type="number" 
                            id="unit_price" 
                            className="form-control" 
                            aria-describedby="unit_price"
                            value={this.props.state.form.unit_price.value}
                            onChange={this.props.handleDetChange} />
                  </div>
               </div>
            </form>
         </div>
      );
   }
}

export default ExchCapForm;